import { AfterContentInit, Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { LayoutHeaderMainContentDirective, LayoutHeaderRightContentDirective } from './layout-header-templates';

@Component({
    selector: 'ig-layout-header',
    templateUrl: './layout-header.component.html',
    styleUrls: ['./layout-header.component.scss'],
    standalone: false
})
export class LayoutHeaderComponent implements AfterContentInit {
  @Input() logoLink?: string[];

  /**
   * one <ng-template igLayoutHeaderMainContent> which will be projected in main header area
   * @ignore
   */
  @ContentChild(LayoutHeaderMainContentDirective) mainContentChild?: LayoutHeaderMainContentDirective;

  /**
   * one <ng-template igLayoutHeaderRightContent> which will be projected in right header area
   * * @ignore
   */
  @ContentChild(LayoutHeaderRightContentDirective) rightContentChild?: LayoutHeaderRightContentDirective;

  /**
   * @ignore
   */
  mainContentTemplate?: TemplateRef<unknown>

  /**
   * @ignore
   */
  rightContentTemplate?: TemplateRef<unknown>

  /**
   * @ignore
   */
  ngAfterContentInit() {
    if (this.mainContentChild) {
      this.mainContentTemplate = this.mainContentChild.templateRef;
    }

    if (this.rightContentChild) {
      this.rightContentTemplate = this.rightContentChild.templateRef;
    }
  }
}
